import {useEffect, useState} from 'react'
import {BASE_URL} from '../modules/config'
import axios from 'axios'
import {IInvoiceListArray} from '../modules/Billing/core/_model'
import {ISelectOption} from '../utils/core/_model'
import {mapToSelectOptions} from '../utils/helperFunction/array.helper'

const GET_INVOICE_LIST_URL = `${BASE_URL}/api/protect/getInvoiceList`

const useInvoiceList = () => {
  const [invoices, setInvoices] = useState<ISelectOption[]>([])

  useEffect(() => {
    const getInvoiceList = async () => {
      try {
        const res = await axios.get<IInvoiceListArray>(GET_INVOICE_LIST_URL)
        const data = await res.data
        const options = mapToSelectOptions(data, {
          idKey: 'id',
          labelKey: 'invoice_no',
          valueKey: 'invoice_no',
        })

        setInvoices(options || [])
      } catch (error) {
        console.log(error)
      }
    }

    getInvoiceList()
  }, [])

  return {invoices}
}

export default useInvoiceList
